<template>
  <div class="flex items-center gap-3 text-s-medium">
    <div
      v-for="item in items"
      :key="item.value"
      class="cursor-pointer transition-colors duration-200"
      :class="[
        modelValue === item.value
          ? 'text-brand-blue1 underline'
          : 'text-black-white hover:text-blue-dark-hover',
      ]"
      @click="modelValue = item.value"
    >
      {{ item.label }}
    </div>
  </div>
</template>

<script lang="ts" setup>
  export interface TabItem {
    label: string
    value: string
  }

  defineProps<{
    items: TabItem[]
  }>()

  const modelValue = defineModel<string>({ required: true })
</script>

<style lang="scss" scoped></style>
